export default function getGa4SessionId(gtagClientId) {
  return new Promise((resolve) => {
    if (!window.gtag || !gtagClientId) resolve(null);
    window.gtag('get', gtagClientId, 'session_id', resolve);
  });
}
